
import { Button } from '@/components/core/Button';
import {
    Dialog,
    DialogBody,
    DialogClose,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogHeaderDefault,
} from '@/components/core/Dialog';
import { useToast } from '@/hooks/useToast';
import { useTranslation } from '@/hooks/useTranslation';
import { logger } from '@/services/logger';

import { useDeleteBulkSubscriptionEntries } from '../bulk-subscriptions.queries';
import { BulkSubscription } from '../bulk-subscriptions.types';

const DeleteAllEntriesConfirmationDialog = ({
    entity,
    open,
    onClose,
}: {
    entity: BulkSubscription,
    open: boolean;
    onClose: (shouldRefetchData?: boolean) => void;
}) => {

    const { toast } = useToast();
    const { t } = useTranslation();

    const { mutate: deleteBulkSubscriptionEntries, isPending: isDeletePending } = useDeleteBulkSubscriptionEntries({
        onSuccess: () => {
            toast.success('BULK_SUBSCRIPTION.ENTRIES_DELETED_SUCCESSFULLY');
            onClose(true);
        },
        onError: (error) => {
            logger.error('DeleteAllEntriesConfirmationDialog: ', error);
            toast.error('ERROR_OCCURRED');
        }
    });

    const deleteEntities = () => {
        deleteBulkSubscriptionEntries({ bulkSubscriptionId: entity.id });
    };

    return (
        <Dialog open={open} onOpenChange={() => onClose()}>
            <DialogContent
                variant="small"
                onPointerDownOutside={() => onClose()}
                onInteractOutside={() => onClose()}
            >
                <DialogHeader>
                    <DialogHeaderDefault>
                        {t('CONFIRM_DELETE')}
                    </DialogHeaderDefault>
                </DialogHeader>

                <DialogBody padding="none" className="tw-p-4">
                    <div>{t('BULK_SUBSCRIPTION.DELETE_ALL_ENTRIES_CONFIRMATION')}</div>
                </DialogBody>
                <DialogFooter>
                    <Button
                        type="button"
                        variant="destructive"
                        disabled={isDeletePending}
                        loading={isDeletePending}
                        onClick={deleteEntities}
                    >
                        {t('ACTION.DELETE')}
                    </Button>
                    <DialogClose asChild={true}>
                        <Button variant="secondary" onClick={() => onClose()} disabled={isDeletePending}>
                            {t('NO')}
                        </Button>
                    </DialogClose>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};

export { DeleteAllEntriesConfirmationDialog };
